export enum FileAssociationEntityType {
  COMM_INBOUND_EMAIL = "comm_inbound_email",
  AI_AGENT_RUN = "ai_agent_run",
  AR_DISCOUNT = "ar_discount",
  AR_COLLECTION_THREAD = "ar_collection_thread",
  AI_THREAD_MESSAGE = "ai_thread_message",
  CORE_DOCUMENT_TRANSFORMATION = "core_document_transformation",
  PRICING_SPA_SOURCE = "pricing_spa_source",
}

export enum DocumentAssociationType {
  ORIGINAL_FILE = "original_file",
  TRANSFORMED_FILE = "transformed_file",
  EMAIL = "email",
  REBATE_TRANSACTION_RECORD = "rebate_invoice",
  EMAIL_ATTACHMENT = "email_attachment",
  EMAIL_LINK = "email_link",
  INVOICE_PDF = "invoice_pdf",
  INVOICE_SUPPORTING_DOC = "invoice_supporting_doc",
  PO_DOCUMENT = "po_document",
  SD_849_PROOF_ATTACHMENT = "sd_849_proof_attachment",
  SD_849_RESPONSE_EXCEL = "sd_849_response_excel",
  SUSTAINABLE_SUPPLIER_CHARTER = "sustainable_supplier_charter",
  OPERATOR_RECORDING = "operator_recording",
  OPERATOR_DOWNLOAD = "operator_download",
  DISCOUNT_ATTACHMENT = "discount_attachment",
  WORKFLOW_LOG = "workflow_log",
  CHAT_ATTACHMENT = "chat_attachment",
  VM_PRICELISTS = "vm_pricelists",
  UNKNOWN = "unknown",
}
